export const items1 = [
  {
    height: 276,
    hideTitle: true,
    imageAlt: 'personalised birthday cards for all',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/spring19/birthday_576x276.jpg?version=498a2b',
    link: '/uk/search/facet/?f=occasion_level_2:occasion>birthday',
    linkAs: 'a',
    title: '',
    width: 576,
  },
  {
    nodes: [
      {
        height: 76,
        hideTitle: true,
        imageAlt: 'Birthday cards for Her',
        imageUrl:
          'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/button_for-her.jpg?version=4926e5',
        link:
          '/uk/search/facet/?f=occasion_level_2:occasion>birthday%7Crecipient_level_2:recipient>female',
        linkAs: 'a',
        title: '',
        width: 276,
      },
      {
        height: 76,
        hideTitle: true,
        imageAlt: 'Birthday cards for Him',
        imageUrl:
          'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/button_for-him.jpg?version=4926e5',
        link:
          '/uk/search/facet/?f=occasion_level_2:occasion>birthday%7Crecipient_level_2:recipient>male',
        linkAs: 'a',
        title: '',
        width: 276,
      },
      {
        height: 76,
        hideTitle: true,
        imageAlt: 'Birthday cards for kids',
        imageUrl:
          'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/button_for-kids.jpg?version=4926e5',
        link:
          '/uk/search/facet/?f=occasion_level_2:occasion>birthday%7Cage_level_2:age>kid',
        linkAs: 'a',
        title: '',
        width: 276,
      },
    ],
  },
  {
    nodes: [
      {
        height: 76,
        hideTitle: true,
        imageAlt: 'Birthday cards for Mum',
        imageUrl:
          'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/button_for-mum.jpg?version=4926e5',
        link:
          '/uk/search/facet/?f=occasion_level_2:occasion>birthday%7Crecipient_level_3:recipient>female>mum',
        linkAs: 'a',
        title: '',
        width: 276,
      },
      {
        height: 76,
        hideTitle: true,
        imageAlt: 'Birthday cards for Dad',
        imageUrl:
          'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/button_for-dad.jpg?version=4926e5',
        link:
          '/uk/search/facet/?f=occasion_level_2:occasion>birthday%7Crecipient_level_3:recipient>male>dad',
        linkAs: 'a',
        title: '',
        width: 276,
      },
      {
        height: 76,
        hideTitle: true,
        imageAlt: 'Birthday cards for Friends',
        imageUrl:
          'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/button_for-friends.jpg?version=4926e5',
        link:
          '/uk/search/facet/?f=occasion_level_2:occasion>birthday%7Ctheme_level_2:theme>friendship',
        linkAs: 'a',
        title: '',
        width: 276,
      },
    ],
  },
]

export const items2 = [
  {
    height: 276,
    width: 276,
    link:
      'https://www.moonpig.com/uk/search/facet/?f=occasion_level_2:occasion>birthday&q=photo+upload',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/spring19/photo-upload_276x276.jpg?version=496f38?epichannel=Desktop',
    imageAlt: 'personalised photo cards',
    title: 'Photo Upload',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link:
      'https://www.moonpig.com/uk/search/facet/?f=occasion_level_2:occasion>birthday|design:funny',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/photo-upload_276x276.jpg?version=4926e5',
    imageAlt: 'Funny cards',
    title: 'Funny Cards',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link:
      'https://www.moonpig.com/uk/search/facet/?f=occasion_level_2:occasion>birthday&q=milestones',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/27-03-19/milestone_276x276.jpg?version=495fd9?epichannel=Desktop',
    imageAlt: 'Milestone birthday cards',
    title: 'Milestones',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link:
      'https://www.moonpig.com/uk/search/promo/?f=occasion_level_2:occasion>birthday&fq=promotionid:4083',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/spring19/new-cards_276x276.jpg?version=496f38?epichannel=Desktop',
    imageAlt: 'New cards',
    title: 'New cards',
    hideTitle: false,
  },
]

export const items3 = [
  {
    height: 276,
    width: 276,
    link:
      '/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday%7Ctheme_level_2:theme%3Eanimals',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/27-03-19/animals_276x276.jpg?version=495fd9',
    imageAlt: 'Animals',
    title: 'Animal Cards',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link:
      '/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday&fq=&q=football',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/27-03-19/football_276x276.jpg?version=495fd9',
    imageAlt: 'Football birthday cards',
    title: 'Football Cards',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link:
      '/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday&fq=&q=Disney',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/27-03-19/disney_276x276.jpg?version=495fd9',
    imageAlt: 'Disney',
    title: 'Disney Cards',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link:
      '/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday&fq=&q=Harry%20Potter',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/27-03-19/harry-potter_276x276.jpg?version=495fd9',
    imageAlt: 'Harry Potter Cards',
    title: 'Harry Potter',
    hideTitle: false,
  },
]

export const items4 = [
  {
    height: 276,
    width: 276,
    link: '/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday&q=giant',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/giant_birthday_cards.jpg?version=49279e',
    imageAlt: 'Giant',
    title: 'Giant Cards',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link: '/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday&q=large',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/large_276x276.jpg?version=4926e5',
    imageAlt: 'Large cards',
    title: 'Large Cards',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link: '/uk/card-packs/',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/card-pack/kids-invites.png?version=4aa8d1',
    imageAlt: 'Multipack cards',
    title: 'Multipack Cards',
    hideTitle: false,
  },
  {
    height: 276,
    width: 276,
    link:
      '"/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday&q=invitation',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/feb2019/invites_276x276.jpg?version=4926e5',
    imageAlt: 'Invitaions cards',
    title: 'Invitations Cards',
    hideTitle: false,
  },
]

export const items5 = [
  {
    height: 281,
    width: 587,
    link:
      '/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday&q=invitation',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/update/birthday-gifts_576x276.jpg?version=4ae2ee',
    imageAlt: 'Birthday Gifts',
    title: 'Birthday Gifts',
    hideTitle: true,
  },
  {
    height: 281,
    width: 587,
    link:
      '/uk/search/facet/?f=occasion_level_2:occasion%3Ebirthday&fq=&q=football',
    linkAs: 'a',
    imageUrl:
      'https://d1xkhapf8f3lxw.cloudfront.net/uk/globalassets/birthday-cards/update/birthday-flowers_576x276.jpg?version=4ae2e6',
    imageAlt: 'Birthday Flowers',
    title: 'Birthday Flowers',
    hideTitle: true,
  },
]